export enum EGeoSearchTypes {
  REGION,
  REGION_WITH_UNDERGROUND,
  CITY_WITH_DISTRICTS_UNDERGROUND,
  CITY_WITH_DISTRICTS,
  CITY,
}
